export default {
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setSelectedYear (state: {[key:string]: number}, value: number) {
    state.selectedYear = value
  }
}
